; (function (root, factory) {
  'use strict'
  var cfg = factory()

  if (typeof module === 'object' && module.exports) {
    module.exports = cfg
    return
  }

  try {
    if (root && root.angular && typeof root.angular.module === 'function') {
      root.angular.module('app').constant('allowedFileTypesConfig', cfg)
    }
  } catch (e) {
    console.log('e :>> ', e);
  }

  try {
    root.EP_ALLOWED_FILE_TYPES = cfg
  } catch (e) {
    console.log('e :>> ', e);
  }
})(this, function () {
  'use strict'

  // Upload picker (client portal): `kind` puts a type under "Photos" or "Documents". Photo types are picked as one
  // choice and the file's extension decides which one it saves as. Each document type is its own choice, shown with
  // pickerLabel / pickerHint ({tax_year} is the portal's evidence year). Images and Word / Excel files uploaded as a
  // document are converted to PDF by the server.
  const DOCUMENT_FILE_TYPES = ['pdf', 'docx', 'jpg', 'jpeg', 'png', 'heic']

  return {
    PHOTO: {
      kind: 'photo',
      label: 'Photo',
      cardLabel: 'Photo',
      chipName: "Photo's",
      chipTooltip: `<div class="ep-filetype-chip-tooltip">
										  <div class="ep-filetype-chip-tooltip-title">Photo's</div>
										  <div class="ep-filetype-chip-tooltip-content">Upload photos of the property condition or issues</div>
									  </div>`,
      allowedFileTypes: ['jpg', 'jpeg', 'png', 'heic'],
      fields: [
        {
          key: 'photo_location',
          label: 'Photo location',
          shortLabel: 'Location', // in the upload list's "... needs to be answered"
          showLabel: true,
          type: 'select',
          grouped: true,
          options: [
            { group: 'Interior Photo', value: 'interior_living_room', label: 'Living Room' },
            { group: 'Interior Photo', value: 'interior_kitchen', label: 'Kitchen' },
            { group: 'Interior Photo', value: 'interior_primary_bedroom', label: 'Primary Bedroom' },
            { group: 'Interior Photo', value: 'interior_primary_bathroom', label: 'Primary Bathroom' },
            { group: 'Interior Photo', value: 'interior_bedroom', label: 'Bedroom' },
            { group: 'Interior Photo', value: 'interior_bathroom', label: 'Bathroom' },
            { group: 'Interior Photo', value: 'interior_other', label: 'Other' },
            { group: 'Exterior Photo', value: 'exterior_front_view', label: 'Front View' },
            { group: 'Exterior Photo', value: 'exterior_back_view', label: 'Back View' },
            { group: 'Exterior Photo', value: 'exterior_side_view', label: 'Side View' },
            { group: 'Exterior Photo', value: 'exterior_facade', label: 'Facade' },
            { group: 'Exterior Photo', value: 'exterior_landscaping', label: 'Landscaping' },
            { group: 'Exterior Photo', value: 'exterior_fence', label: 'Fence' },
            { group: 'Exterior Photo', value: 'exterior_other', label: 'Other' },
            // A placeholder answer (the upload list's "Fill in later" button): the photo can be uploaded and its location
            // set later. The report puts it under "Unknown location"; the AI never picks it.
            { group: 'Not sure yet', value: 'fill_in_later', label: 'Fill in Later', placeholder: true }
          ]
        },
        {
          key: 'photo_location_other',
          label: 'Photo location (other)',
          shortLabel: 'Location (other)',
          type: 'text',
          maxLength: 40,
          fullWidth: true,
          showLabel: true,
          showWhen: { key: 'photo_location', in: ['interior_other', 'exterior_other'] }
        },
        { key: 'issue_existed_jan1', label: 'This issue existed on January 1st', shortLabel: 'Issue existed on Jan 1', showLabel: false, type: 'checkbox', requiredMode: 'checked' },
        { key: 'photo_notes', label: 'Notes (optional)', shortLabel: 'Notes', showLabel: true, type: 'textarea', rows: 3, maxLength: 500, fullWidth: true, required: false }
      ]
    },
    PHOTOS_PDF: {
      kind: 'photo',
      label: 'Photos (PDF)',
      cardLabel: 'Photos (PDF)',
      chipName: "Photos (PDF)'s",
      chipTooltip: `<div class="ep-filetype-chip-tooltip">
                      <div class="ep-filetype-chip-tooltip-title">Photos (PDF)'s</div>
                      <div class="ep-filetype-chip-tooltip-content">Upload photos of the property condition or issues in PDF format</div>
                    </div>`,
      allowedFileTypes: ['pdf'],
      fields: [
        { key: 'photo_notes', label: 'Notes (optional)', showLabel: true, type: 'textarea', rows: 3, maxLength: 500, fullWidth: true, required: false }
      ]
    },
    PHOTOS_DOCX: {
      kind: 'photo',
      label: 'Photos (Word Document)',
      cardLabel: 'Photos (Word Document)',
      chipName: "Photos (Word Document)'s",
      chipTooltip: `<div class="ep-filetype-chip-tooltip">
                      <div class="ep-filetype-chip-tooltip-title">Photos (Word Document)'s</div>
                      <div class="ep-filetype-chip-tooltip-content">Upload photos of the property condition or issues in Word Document format</div>
                    </div>`,
      allowedFileTypes: ['docx'],
      fields: [
        { key: 'photo_notes', label: 'Notes (optional)', showLabel: true, type: 'textarea', rows: 3, maxLength: 500, fullWidth: true, required: false }
      ]
    },
    ESTIMATE_NEEDED_REPAIR: {
      kind: 'document',
      pickerLabel: 'Estimate of Repair Costs',
      pickerHint: 'Dated within the last year',
      label: 'Estimate of Needed Repair',
      cardLabel: 'Estimate',
      chipName: "Estimate's",
      chipTooltip: `<div class="ep-filetype-chip-tooltip">
                      <div class="ep-filetype-chip-tooltip-title">Estimate's</div>
                      <div class="ep-filetype-chip-tooltip-content">Upload estimates for needed repairs to the property that were present on January 1st</div>
                    </div>`,
      allowedFileTypes: DOCUMENT_FILE_TYPES.concat(['xlsx']),
      fields: [
        {
          key: 'estimate_scope',
          label: 'Repair scope',
          showLabel: true,
          type: 'select',
          required: true,
          options: [
            { value: 'exterior', label: 'Exterior' },
            { value: 'interior', label: 'Interior' },
            { value: 'roof', label: 'Roof' },
            { value: 'foundation', label: 'Foundation' },
            { value: 'other', label: 'Other' }
          ]
        },
        {
          key: 'estimate_scope_other',
          label: 'Repair scope (other)',
          showLabel: true,
          type: 'text',
          maxLength: 40,
          fullWidth: true,
          showWhen: { key: 'estimate_scope', equals: 'other' }
        },
        { key: 'estimate_date', label: 'Date of Estimate', showLabel: true, type: 'date' },
        { key: 'estimate_amount', label: 'Amount', showLabel: true, type: 'amount' },
        { key: 'estimate_notes', label: 'Notes (optional)', showLabel: true, type: 'textarea', rows: 3, maxLength: 500, fullWidth: true, required: false }
      ]
    },
    INVOICE_REPAIRS_COMPLETED: {
      kind: 'document',
      pickerLabel: 'Invoice of Repair Costs',
      pickerHint: 'For repairs completed after January 1, {tax_year}',
      label: 'Invoice for Repairs Completed',
      cardLabel: 'Invoice',
      chipName: "Invoice's",
      chipTooltip: `<div class="ep-filetype-chip-tooltip">
                      <div class="ep-filetype-chip-tooltip-title">Invoice's</div>
                      <div class="ep-filetype-chip-tooltip-content">Upload invoices for repairs that have been completed after January 1st</div>
                    </div>`,
      allowedFileTypes: DOCUMENT_FILE_TYPES.concat(['xlsx']),
      fields: [
        { key: 'invoice_date', label: 'Date of Invoice', showLabel: true, type: 'date' },
        { key: 'invoice_amount', label: 'Amount', showLabel: true, type: 'amount' },
        { key: 'invoice_notes', label: 'Notes (optional)', showLabel: true, type: 'textarea', rows: 3, maxLength: 500, fullWidth: true, required: false }
      ]
    },
    INSURANCE_CLAIM_DAMAGE: {
      kind: 'document',
      pickerLabel: 'Insurance Claim',
      pickerHint: 'Filed within the last year',
      label: 'Insurance Claim for Damage',
      cardLabel: 'Insurance Claim',
      chipName: "Insurance Claim's",
      chipTooltip: `<div class="ep-filetype-chip-tooltip">
                      <div class="ep-filetype-chip-tooltip-title">Insurance Claim's for Damage</div>
                      <div class="ep-filetype-chip-tooltip-content">Upload any insurance claims filed for property damage that occurred prior to January 1st</div>
                    </div>`,
      allowedFileTypes: DOCUMENT_FILE_TYPES,
      fields: [
        { key: 'ins_claim_date', label: 'Date of Loss', showLabel: true, type: 'date' },
        { key: 'ins_claim_amount', label: 'Amount', showLabel: true, type: 'amount' },
        { key: 'ins_claim_notes', label: 'Notes (optional)', showLabel: true, type: 'textarea', rows: 3, maxLength: 500, fullWidth: true, required: false }
      ]
    },
    PURCHASE_DOCUMENT: {
      kind: 'document',
      pickerLabel: 'Purchase Documents',
      pickerHint: 'Property acquired within the last year',
      label: 'Purchase Document',
      cardLabel: 'Purchase Document',
      chipName: "Purchase Document's",
      chipTooltip: `<div class="ep-filetype-chip-tooltip">
                      <div class="ep-filetype-chip-tooltip-title">Purchase Document's</div>
                      <div class="ep-filetype-chip-tooltip-content">Upload documents related to the purchase of the property, such as:</div>
                      <ul class="ep-filetype-chip-tooltip-list">
                        <li>Closing Disclosure</li>
                        <li>Settlement Statement</li>
                        <li>HUD-1</li>
                      </ul>
                    </div>`,
      allowedFileTypes: DOCUMENT_FILE_TYPES,
      fields: [
        { key: 'purchase_date', label: 'Close date', showLabel: true, type: 'date' },
        { key: 'purchase_price', label: 'Purchase price (optional)', showLabel: true, type: 'amount', required: false },
        { key: 'purchase_notes', label: 'Notes (optional)', showLabel: true, type: 'textarea', rows: 3, maxLength: 500, fullWidth: true, required: false }
      ]
    },
    FEE_APPRAISAL: {
      kind: 'document',
      pickerLabel: 'Fee Appraisal',
      pickerHint: 'Completed within the last year',
      label: 'Fee Appraisal',
      cardLabel: 'Appraisal',
      chipName: "Appraisal's",
      chipTooltip: `<div class="ep-filetype-chip-tooltip">
                      <div class="ep-filetype-chip-tooltip-title">Appraisal Document's</div>
                      <div class="ep-filetype-chip-tooltip-content">Upload appraisals obtained for the property from a third-party appraiser (Not the notice from the Centralized Appraisal District)</div>
                    </div>`,
      allowedFileTypes: DOCUMENT_FILE_TYPES,
      fields: [
        {
          key: 'appraisal_purpose',
          label: 'Purpose of Appraisal',
          showLabel: true,
          type: 'select',
          options: [
            { value: 'purchase', label: 'Purchase' },
            { value: 'refinance', label: 'Refinance' },
            { value: 'family_planning', label: 'Family Planning' },
            { value: 'other', label: 'Other' }
          ]
        },
        {
          key: 'appraisal_purpose_other',
          label: 'If other, what was the reason?',
          type: 'text',
          maxLength: 40,
          fullWidth: true,
          showLabel: true,
          showWhen: { key: 'appraisal_purpose', equals: 'other' }
        },
        { key: 'appraisal_date', label: 'Date of Valuation', showLabel: true, type: 'date' },
        { key: 'appraised_value', label: 'Appraiser Opinion of Value', showLabel: true, type: 'amount', required: true },
        { key: 'appraisal_notes', label: 'Notes (optional)', showLabel: true, type: 'textarea', rows: 3, maxLength: 500, fullWidth: true, required: false }
      ]
    },
    // Reference only (referenceOnly): a CMA or a home-value website page (Zillow, Redfin...) the owner found. Agents
    // see it in the review tool, but it never goes on the report (reportController skips it, the AI doesn't set it to
    // Do Not Use).
    CMA_ZILLOW_INFO: {
      kind: 'document',
      referenceOnly: true,
      pickerLabel: 'CMA / Zillow Info',
      pickerHint: 'Market analysis or home value page',
      label: 'CMA / Zillow Info',
      cardLabel: 'CMA / Zillow',
      chipName: 'CMA / Zillow Info',
      chipTooltip: `<div class="ep-filetype-chip-tooltip">
                      <div class="ep-filetype-chip-tooltip-title">CMA / Zillow Info</div>
                      <div class="ep-filetype-chip-tooltip-content">Upload a Comparative Market Analysis from a real estate agent, or a page from Zillow, Redfin, Realtor.com or a similar site showing your home's value or nearby sales</div>
                    </div>`,
      allowedFileTypes: DOCUMENT_FILE_TYPES,
      fields: [
        {
          key: 'cma_source',
          label: 'Source',
          showLabel: true,
          type: 'select',
          required: true,
          options: [
            { value: 'agent_cma', label: 'Real estate agent CMA' },
            { value: 'zillow', label: 'Zillow' },
            { value: 'redfin', label: 'Redfin' },
            { value: 'realtor_com', label: 'Realtor.com' },
            { value: 'other', label: 'Other' }
          ]
        },
        {
          key: 'cma_source_other',
          label: 'Source (other)',
          showLabel: true,
          type: 'text',
          maxLength: 40,
          fullWidth: true,
          showWhen: { key: 'cma_source', equals: 'other' }
        },
        { key: 'cma_date', label: 'Date', showLabel: true, type: 'date' },
        { key: 'cma_value', label: 'Value shown (optional)', showLabel: true, type: 'amount', required: false },
        { key: 'cma_notes', label: 'Notes (optional)', showLabel: true, type: 'textarea', rows: 3, maxLength: 500, fullWidth: true, required: false }
      ]
    }
  }
})
